/**
 * Remoting XPAC API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DeploymentStatus = 'unknown' | 'inProgress' | 'finished' | 'pending' | 'scheduled';

export const DeploymentStatus = {
    Unknown: 'unknown' as DeploymentStatus,
    InProgress: 'inProgress' as DeploymentStatus,
    Finished: 'finished' as DeploymentStatus,
    Pending: 'pending' as DeploymentStatus,
    Scheduled: 'scheduled' as DeploymentStatus
};

